import React, { createContext, useContext, useState, useEffect } from 'react';
import { getCurrentUser } from '../lib/api';
import { getStoredAdvertiser, setAuthData, clearAuthData } from '../lib/utils';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    // Initialize from localStorage immediately to prevent redirect flash
    const [advertiser, setAdvertiser] = useState(() => {
        const stored = getStoredAdvertiser();
        return stored;
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const initAuth = async () => {
            const token = localStorage.getItem('hmc_token');
            if (token) {
                try {
                    const response = await getCurrentUser();
                    setAdvertiser(response.data);
                    // Update stored data with fresh data
                    localStorage.setItem('hmc_advertiser', JSON.stringify(response.data));
                } catch (error) {
                    console.error('Auth init error:', error);
                    clearAuthData();
                    setAdvertiser(null);
                }
            } else {
                setAdvertiser(null);
            }
            setLoading(false);
        };
        initAuth();
    }, []);

    const login = (token, advertiserData) => {
        setAuthData(token, advertiserData);
        setAdvertiser(advertiserData);
    };

    const logout = () => {
        clearAuthData();
        setAdvertiser(null);
    };

    return (
        <AuthContext.Provider value={{ advertiser, login, logout, loading, isAuthenticated: !!advertiser }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};
